<template>
  <div class="no-gutters mr-0 pr-0">
    <table class="table-bordered table-evaluation-info">
      <tr>
        <td>
          <div class="mt-3">
            <p class="font-weight-bold mb-3">{{$t('medium_grant_ev.general__info_grid_by')}}</p>
            <div v-if="EvaluationForm.evaluation && EvaluationForm.evaluation.user">
              <div>{{EvaluationForm.evaluation.user.name}}</div>
              <small>{{EvaluationForm.evaluation.updated_at}}</small>
            </div>
            <div v-else>-</div>
          </div>
        </td>
      </tr>
      <tr height="100">
        <td valign="center">
          <h1 class="m-0 p-0">TOTAL SCORE <span class="ml-4">{{EvaluationForm.model.final_result_score}}</span></h1>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
  import {EvaluationForm, UserRoles} from "@/services";

  export default {
    data() {
      return {
        EvaluationForm,
        UserRoles,
        loggedUser: {}
      }
    },
    computed: {
      totalScore: function () {
        let total = 0;
        total += EvaluationForm.model.awarded_quantified || 0;
        total += EvaluationForm.model.awarded_strategic || 0;
        total += EvaluationForm.model.criteria_one_two || 0;
        total += EvaluationForm.model.criteria_one_three || 0;
        total += EvaluationForm.model.criteria_one_four || 0;
        total += EvaluationForm.model.criteria_one_five || 0;
        total += EvaluationForm.model.criteria_one_six || 0;
        total += EvaluationForm.model.criteria_one_seven || 0;
        total += EvaluationForm.model.criteria_one_eight || 0;
        total += EvaluationForm.model.criteria_two_one || 0;
        total += EvaluationForm.model.criteria_two_two || 0;
        total += EvaluationForm.model.criteria_two_three || 0;
        total += EvaluationForm.model.criteria_three_one || 0;
        total += EvaluationForm.model.criteria_three_two || 0;
        total += EvaluationForm.model.criteria_four_one || 0;
        total += EvaluationForm.model.criteria_five_one || 0;

        EvaluationForm.totalScore = total;

        return total;
      }
    },
    inject: ['validateEvaluation'],
    created() {

    },
    beforeMount() {
      let vm = this;
      setTimeout(function() {
        EvaluationForm.totalScore = vm.totalScore;
      }, 200);
    },
    mounted() {
      let vm = this;
      vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
    }
  }
</script>
<style lang="scss" scoped>
  .table-risk-assesment td {
    padding-bottom: 0 !important;
    padding-left: 0 !important;
  }
</style>
